module.exports = __webpack_public_path__ + "static/media/stephbaby.0161d3ea.jpg";